// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__sOh9d","icon":"styles_icon__dtRNY","text":"styles_text__-Rpqg"};